var inMap = function inMap(_a) {
  var map = _a.map,
    _b = _a.message,
    message = _b === void 0 ? 'Выберите значение' : _b;
  return function (value) {
    if (map.has(value)) {
      return;
    }
    return message;
  };
};
export default inMap;
export { inMap };